import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Logo, MonoLabel, CtaButton } from "../components/kit";
import api from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | ok | pending
  const tries = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("pending"); return; }
    const poll = async () => {
      tries.current += 1;
      try {
        const r = await api.get(`/billing/checkout/status/${sid}`);
        if (r.data.payment_status === "paid") { setState("ok"); setTimeout(() => navigate("/app/billing"), 2500); return; }
      } catch { /* keep polling */ }
      if (tries.current < 6) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [params, navigate]);

  return (
    <div className="min-h-screen dot-grid flex flex-col" data-testid="payment-success-page">
      <div className="max-w-6xl w-full mx-auto px-6 py-6"><Link to="/"><Logo className="h-5 sm:h-6" /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4 pb-24">
        <div className="w-full max-w-md card-soft p-8 sm:p-10 text-center fade-up">
          {state === "checking" && <p className="text-[14px] text-[#54505B]" data-testid="payment-checking">Confirming your payment…</p>}
          {state === "ok" && (
            <div data-testid="payment-confirmed">
              <MonoLabel>PAYMENT CONFIRMED</MonoLabel>
              <h1 className="mt-3 text-2xl"><span className="font-serif-it">Welcome aboard.</span></h1>
              <p className="mt-3 text-[14px] text-[#54505B]">Plan active and credits topped up. Taking you to billing…</p>
            </div>
          )}
          {state === "pending" && (
            <div data-testid="payment-pending">
              <MonoLabel>ALMOST THERE</MonoLabel>
              <p className="mt-4 text-[14px] text-[#54505B]">We're still confirming your payment — check the Plans page in a moment.</p>
              <CtaButton className="w-full mt-6" onClick={() => navigate("/app/billing")}>Go to Plans</CtaButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
